exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.aw-nav-link {\n  background-color: #eee;\n  border: 2px solid #eee !important;\n  border-bottom: none !important;\n  margin-left: 0.1em;\n  margin-right: 0.1em;\n  border-top-left-radius: 0.5rem !important;\n  border-top-right-radius: 0.5rem !important;\n}\n.aw-nav-link:hover {\n  background-color: #fff;\n}\n.aw-nav-item:hover {\n  background-color: #fff !important;\n}\n", ""]);

// exports
